import { useEffect } from "react";
import NavigationLayout from "../navigation/navigationLayout";
import FooterLayout from "../footer/footerLayout";
import GamePlayView from "./gamePlayView";

const GamePlayLayout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <GamePlayView />

            <FooterLayout />
        </>
    );
}

export default GamePlayLayout;